import { render } from "./ModalPromotionInvoiceList.vue?vue&type=template&id=d66370ae&scoped=true"
import script from "./ModalPromotionInvoiceList.vue?vue&type=script&lang=js"
export * from "./ModalPromotionInvoiceList.vue?vue&type=script&lang=js"

import "./ModalPromotionInvoiceList.vue?vue&type=style&index=0&id=d66370ae&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66370ae"]])

export default __exports__